<template>
  <div>
    <div
      class="d-flex flex-column pt-5 bgi-size-cover bgi-no-repeat rounded-top"
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    >
      <h4 class="d-flex flex-center rounded-top">
        <span class="text-white">{{ $t('notifications.self')}}</span>
        <span v-if="count"
          class="btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2"
        >
          {{ count }}
        </span>
      </h4>

      <div class="p-8 bg-white">
        <perfect-scrollbar
            class="scroll pr-7 mr-n7"
            style="max-height: 40vh; position: relative;"
        >
          <template v-for="(item, i) in items">
            <!--begin::Item-->
            <div class="d-flex align-items-center mb-6 cursor-pointer" v-bind:key="i" @click.prevent="onClickNotification(item)">
              <!--begin::Symbol-->
              <div
                  class="symbol symbol-40 mr-5"
                  v-bind:class="`symbol-light-${item.color}`"
              >
                <span class="symbol-label">
                  <span
                      class="svg-icon svg-icon-lg"
                      v-bind:class="`svg-icon-${item.color}`"
                  >
                    <!--begin::Svg Icon-->
                    <inline-svg :src="item.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </span>
              </div>
              <!--end::Symbol-->
              <!--begin::Text-->
              <div class="d-flex flex-column" :class="item.read_at ? '' : 'font-weight-bold'">
                <a
                    href="#"
                    @click.prevent="onClickNotification(item)"
                    class="text-hover-primary mb-1 font-size-lg"
                    :class="item.read_at ? '' : 'font-weight-bold'"
                >
                  {{ item.title }}
                </a>
                <span class="text-muted" :class="item.read_at ? '' : 'font-weight-bold'">
                  {{ item.message }}
                </span>
              </div>
              <!--end::Text-->
            </div>
            <!--end::Item-->
          </template>

          <template v-if="!items || !items.length">
            <div class="text-center">
              <span class="text-center"> {{ $t('notifications.no_notification')}} </span>
            </div>
          </template>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}
</style>

<script>

import baseModule, {
  ERROR,
  BASE_URL,
  ITEMS,
  COUNT,
  MODULE_NAME as BASE_MODULE,
  UPDATE_ITEM,
  GET_ITEMS
} from "@/core/services/store/notification.module";
import store from "@/core/services/store";

const _BASE_MODULE = BASE_MODULE;

export default {
  name: "KTDropdownNotification",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_BASE_MODULE, baseModule);
  },
  data() {
    return {};
  },
  methods: {
    onClickNotification(item) {
      if (item && item.route) {
        this.readNotification(item)
        this.filterResults()
        this.$emit("notification-clicked", item);
        return false;
      }
    },
    filterResults() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch(_BASE_MODULE + '/' + GET_ITEMS, {
        filters: this.filters,
      });
    },
    readNotification(item) {
      let url = BASE_URL + '/' + item.id;
      this.$store.dispatch(_BASE_MODULE + '/' + UPDATE_ITEM, {
        url: url,
      });
    },
  },
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/misc/bg-1.jpg";
    },
    count() {
      let countData =  store.getters[_BASE_MODULE + "/" + COUNT];

      if (countData && countData.hasOwnProperty('count')) {
        return countData.count;
      }

      return 0;
    },
    error() {
      return store.getters[_BASE_MODULE + "/" + ERROR];
    },
    items() {
      let results = [];
      let items = store.getters[_BASE_MODULE + "/" + ITEMS] || [];

      if (items) {
        items.forEach(item => {
          let data = JSON.parse(item.data);
          results.push({
            id : item.id,
            message : data.message,
            read_at : item.read_at,
            title: data.title,
            route: data.web_params,
            color: "primary",
            svg: process.env.BASE_URL + "media/svg/icons/Home/Library.svg"
          })
        })
      }

      return results;
    },
    filters() {
      return {
      };
    },
  },
  mounted() {
    this.filterResults();
  }
};
</script>
